import { DefaultPage, InstallPlugin, UpdatePlugin } from './';

export default {
  path: 'plugin/:version/v',
  name: 'Plugin',
  childRoutes: [
    { path: ':projectId', name: 'Default page', component: DefaultPage, isPrivate: true },
    {
      path: ':projectId/install/:pluginId',
      name: 'Install plugin',
      component: InstallPlugin,
      isPrivate: true,
    },
    {
      path: ':projectId/update/:pluginId/:installedPluginId',
      name: 'Install plugin',
      component: UpdatePlugin,
      isPrivate: true,
    },
  ],
};
